"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
import { forwardRef } from "react";
import styles from "./Button.module.css";
import { CircularProgress } from "./CircularProgress";
import { VariantIcon } from "./VariantIcon";
import { marginVariables } from "../../utils/style";
const Button = forwardRef(
  ({
    children,
    variant = "primary",
    size = "large",
    block = false,
    icon: _icon,
    fixedIcon: _fixedIcon,
    suffixIcon: _suffixIcon,
    type = "button",
    disabled = false,
    loading = false,
    onClick,
    m,
    mx,
    my,
    mt,
    mr,
    mb,
    ml,
    ...props
  }, ref) => {
    const icon = loading ? /* @__PURE__ */ jsx(CircularProgress, {}) : _icon === "default" ? /* @__PURE__ */ jsx(VariantIcon, { variant }) : _icon;
    const fixedIcon = _fixedIcon === "default" ? /* @__PURE__ */ jsx(VariantIcon, { variant }) : _fixedIcon;
    const suffixIcon = _suffixIcon === "default" ? /* @__PURE__ */ jsx(VariantIcon, { variant }) : _suffixIcon;
    const cls = clsx({
      [styles.button]: true,
      [styles[variant]]: true,
      [styles[size]]: true,
      [styles.block]: block,
      [styles.disabled]: disabled,
      [styles.loading]: loading
    });
    const handleClick = (e) => {
      if (loading) {
        e.preventDefault();
        return;
      }
      onClick?.(e);
    };
    return /* @__PURE__ */ jsxs(
      "button",
      {
        type,
        className: cls,
        style: {
          ...marginVariables({
            m,
            mx,
            my,
            mt,
            mr,
            mb,
            ml
          })
        },
        ref,
        disabled,
        "aria-disabled": loading,
        onClick: handleClick,
        ...props,
        children: [
          fixedIcon && /* @__PURE__ */ jsx("span", { className: styles.fixedIcon, children: fixedIcon }),
          /* @__PURE__ */ jsxs("span", { className: styles.label, children: [
            icon && /* @__PURE__ */ jsx("span", { className: styles.icon, children: icon }),
            children,
            suffixIcon && /* @__PURE__ */ jsx("span", { className: styles.suffixIcon, children: suffixIcon })
          ] })
        ]
      }
    );
  }
);
Button.displayName = "Button";
export {
  Button
};
